export default __webpack_public_path__ + "static/media/santa-maria-5.57cba78a.jpg";